import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Autocomplete,
    Tooltip,
    Grid,
    InputLabel,
    TextField,
    FormControl,
    InputBase,
    FormControlLabel,
    Checkbox,
    Divider,
    Switch,
    FormGroup,
    Typography,
    Chip,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled, alpha } from "@mui/material/styles";
import React, { useState, useEffect } from "react";
import { useStatePtr } from "@pure-ptr/react";
import { useData } from "@pure-ptr/react";
import {
    Delete as DeleteIcon,
    CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
    CheckBox as CheckBoxIcon,
} from "@mui/icons-material";

import { useSelector } from "react-redux";
import { Formik } from "formik";
import { injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Loadable } from "../../../common";

const useStyles = makeStyles((theme) => ({
    button: {
        padding: "0.25rem",
    },
    formControlAuto: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        rowGap: "20px",
    },
    divider: {
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        marginBottom: "20px",
        padding: "15px 10px 15px 10px",
    },
}));

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const PlanIdMappingDialog = ({
    intl,
    open,
    handleClose,
    planIds = null,
    rowData,
    update,
    isLoading = false,
    selected = [],
    payerContracts
}) => {
    const classes = useStyles();
    const isSliced = useStatePtr(true);

   

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            sx={{ "& .MuiPaper-root": { minWidth: "400px" } }}
        >
            <DialogTitle>Edit Payer Mapping {rowData ? `(1)`:`(${selected?.length})`}</DialogTitle>
            <Loadable loading={isLoading}>
                {selected?.length === 0 && !rowData && (
                    <>
                        <DialogContent>
                            <Typography>
                                No Plan Id Selected , Please select at least one
                                record to proceed
                            </Typography>
                        </DialogContent>

                        <DialogActions>
                            <Button onClick={handleClose}> Close</Button>
                        </DialogActions>
                    </>
                )}
                {(selected?.length > 0 || rowData) && (
                    <Formik
                        enableReinitialize={true}
                        initialValues={{
                            contract: rowData?.payerContract || null,
                            active: rowData?.active || false,
                        }}
                        validate={(values) => {
                            const errors: any = {};

                            if (!values.contract) {
                                errors.contract = intl.formatMessage({
                                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                                });
                            }

                            return errors;
                        }}
                        onSubmit={(values, {}) => {
                            // const payload={ids:selectedItems,statusId:values?.status?.value}
                            // dispatch(updateClaimStatuses(payload,updateStatusCallback))
                            update({
                                planPayerContractIds:
                                    selected?.length > 0
                                        ? selected
                                        : [rowData?.id],
                                payerContractId: values?.contract?.id,
                                active: values?.active,
                            });
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,

                            handleSubmit,
                            setFieldValue,
                        }) => (
                            <form
                                onSubmit={handleSubmit}
                                noValidate
                                autoComplete="off"
                            >
                                <DialogContent>
                                    <Grid container>
                                        <FormControl
                                            className={classes.formControlAuto}
                                        >

                                            <FormControl
                                                className={
                                                    classes.formControlAuto
                                                }
                                            >
                                                <Autocomplete
                                                    onChange={(e, value) =>
                                                        setFieldValue(
                                                            "contract",
                                                            value
                                                        )
                                                    }
                                                    //   filterOptions={filterOptions}
                                                    value={values?.contract}
                                                    options={[
                                                        ...(payerContracts ||
                                                            []),
                                                    ]}
                                                    isOptionEqualToValue={(
                                                        option,
                                                        value
                                                    ) =>
                                                        option.displayName ===
                                                        value.displayName
                                                    }
                                                    disableCloseOnSelect
                                                    getOptionLabel={(
                                                        option: any
                                                    ) =>
                                                        option?.displayName ||
                                                        ""
                                                    }
                                                    renderOption={(
                                                        props,
                                                        option,
                                                        { selected }
                                                    ) => (
                                                        <li {...props}>
                                                            <Checkbox
                                                                icon={icon}
                                                                checkedIcon={
                                                                    checkedIcon
                                                                }
                                                                style={{
                                                                    marginRight: 8,
                                                                }}
                                                                checked={
                                                                    selected
                                                                }
                                                            />
                                                            {option?.displayName ||
                                                                ""}
                                                        </li>
                                                    )}
                                                    renderTags={(
                                                        tagValue,
                                                        getTagProps
                                                    ) => {
                                                        const numTags =
                                                            tagValue.length;
                                                        return (
                                                            <Typography variant="caption">
                                                                {(isSliced.value
                                                                    ? tagValue.slice(
                                                                          0,
                                                                          2
                                                                      )
                                                                    : tagValue
                                                                ).map(
                                                                    (
                                                                        option,
                                                                        index
                                                                    ) => (
                                                                        <Chip
                                                                            size="small"
                                                                            color="secondary"
                                                                            key={
                                                                                index
                                                                            }
                                                                            label={
                                                                                option.name
                                                                            }
                                                                            {...getTagProps(
                                                                                {
                                                                                    index,
                                                                                }
                                                                            )}
                                                                        />
                                                                    )
                                                                )}

                                                                {numTags >
                                                                    2 && (
                                                                    <Chip
                                                                        size="small"
                                                                        sx={{
                                                                            cursor: "pointer",
                                                                        }}
                                                                        onClick={() =>
                                                                            isSliced.set(
                                                                                !isSliced.value
                                                                            )
                                                                        }
                                                                        label={
                                                                            isSliced.value
                                                                                ? ` + ${
                                                                                      numTags -
                                                                                      2
                                                                                  }`
                                                                                : "See Less"
                                                                        }
                                                                    />
                                                                )}
                                                            </Typography>
                                                        );
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Payer Contract"
                                                            error={Boolean(
                                                                errors.contract
                                                            )}
                                                            helperText={
                                                                errors.contract
                                                            }
                                                        />
                                                    )}
                                                />
                                            </FormControl>

                                            <FormGroup>
                                                <Tooltip title="Activate/Deactivate Plan Id Mapping">
                                                    <Typography component="div">
                                                        <Grid
                                                            component="label"
                                                            container
                                                            alignItems="center"
                                                            spacing={0}
                                                            className="mb-0"
                                                        >
                                                            <Grid
                                                                item
                                                                sx={{
                                                                    fontSize:
                                                                        "11px",
                                                                    fontWeight:
                                                                        "500",
                                                                    pr: "10px",
                                                                }}
                                                            >
                                                                Active
                                                            </Grid>
                                                            <Grid item>
                                                                <Switch
                                                                    size="small"
                                                                    // disabled={pending}
                                                                    checked={
                                                                        values?.active
                                                                    }
                                                                    onChange={(
                                                                        e
                                                                    ) =>
                                                                        setFieldValue(
                                                                            "active",
                                                                            e
                                                                                .target
                                                                                .checked
                                                                        )
                                                                    }
                                                                    name="active"
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Typography>
                                                </Tooltip>
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>
                                </DialogContent>
                                <DialogActions >
                                    <Button
                                        type="button"
                                        onClick={handleClose}
                                        className="mr-3"
                                        variant="outlined"
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                    >
                                        Save
                                    </Button>
                                </DialogActions>
                            </form>
                        )}
                    </Formik>
                )}
            </Loadable>
        </Dialog>
    );
};

export default injectIntl(PlanIdMappingDialog);
